const MIXPANEL_BOARD_PROJECT_URL =
  "https://eu.mixpanel.com/project/2793436/view/3328072/app/boards#id=10985942"

type MixpanelFilterInput = {
  resourceType: "user" | "event"
  propertyName: string
  propertyType: "string" | "number"
  filterOperator: "equals" | "contains"
  filterValue: string
}

function jsurlEncodeValue(value: string) {
  return value.replaceAll("@", "*40").replaceAll(" ", "*20")
}

function jsurlEncodePropertyName(name: string) {
  return name.replaceAll("$", "!")
}

function buildFilterJsurl(input: MixpanelFilterInput) {
  const value = jsurlEncodeValue(input.filterValue)
  const prop = jsurlEncodePropertyName(input.propertyName)

  return (
    "~(~(" +
    `resourceType~'${input.resourceType}~` +
    `propertyName~'${prop}~` +
    "propertyObjectKey~null~" +
    `propertyDefaultType~'${input.propertyType}~` +
    `propertyType~'${input.propertyType}~` +
    `filterOperator~'${input.filterOperator}~` +
    `filterValue~(~'${value})~` +
    "limitValues~false~" +
    "defaultEmpty~false~" +
    `activeValue~(~'${value})` +
    "))"
  )
}

export function buildMixpanelBoardUrl(filter: MixpanelFilterInput) {
  const jsurl = buildFilterJsurl(filter)
  return `${MIXPANEL_BOARD_PROJECT_URL}&filters=${encodeURIComponent(jsurl)}`
}
